import { Button } from '@criteria-labs/react'
import { MegaphoneIcon } from '@heroicons/react/24/solid'

export function FeedbackButton() {
  return (
    <Button
      plain
      href="mailto:feedback@criteria.sh?subject=Feedback on Criteria Playground"
      aria-label="Send Feedback"
      data-tooltip-id="playground-header-tooltip"
      data-tooltip-content="Send Feedback"
    >
      <MegaphoneIcon />
    </Button>
  )
}
